export default class ValidationError extends Error {
  static CODE = 'validation'

  constructor(name, reason='invalid', message=`${name} is ${reason}`) {
    super(message)
    this.code = ValidationError.CODE
    this.name = name
    this.reason = reason
  }
}
